<template>
  <LayoutLogin>
    <template v-slot:content>
      <v-sheet rounded min-width="450px" color="white" elevation="12px">
        <v-progress-linear
          height="6"
          :active="isLoading"
          :indeterminate="isLoading"
        />
        <div class="loginCard">
          <Logo class="mt-4 mb-20 mx-auto" type="big" />

          <div class="mt-8">
            <p
              v-if="!hasError"
              class="body1 text-center blue--text my-8"
              data-private
            >
              {{ title }}
            </p>

            <ResetPasswordForm
              v-if="!hasError && account._id"
              :account="account"
              @onSubmit="changePassword"
              @onPasswordUpdated="onPasswordUpdated"
            />

            <AccessResetPasswordError
              class="auth-error"
              v-if="hasError"
              @onClickGoTo="onClickGoTo"
            />
          </div>
        </div>
      </v-sheet>
    </template>
  </LayoutLogin>
</template>

<script>
import api from '../../api'

import mixin from '@/mixins/mixin.vue'
import authMixin from '@/mixins/authMixin.vue'

import UAParser from 'ua-parser-js'
import config from '@/config'
import parseEnvironment from '@/lib/parseEnvironment'

import LayoutLogin from '@/components/Core/Layout/LayoutLogin'

import Logo from '@/components/Core/Logo/Logo.vue'
import AccessResetPasswordError from './components/AccessResetPasswordError.vue'
import ResetPasswordForm from './components/ResetPasswordForm.vue'

export default {
  name: 'AccessResetPassword',

  components: {
    AccessResetPasswordError,
    LayoutLogin,
    Logo,
    ResetPasswordForm,
  },

  mixins: [mixin, authMixin],

  data() {
    return {
      tokenIsValid: true,
      password: '',
      account: {},
      hasError: false,
      isLoading: false,
    }
  },

  created() {
    this.$track('v2.app.account.recover.password', this.$store)

    const mobileWasHandled = this.handleMobileDevice()
    if (!mobileWasHandled) return this.getResetPasswordToken()
  },

  computed: {
    title() {
      return this.$t('auth.access.restore_password')
    },
  },

  methods: {
    handleMobileDevice() {
      const parser = new UAParser()
      const agent = parser.getResult()
      const environment = parseEnvironment(config.reverEnv)
      const token = this.getRouteParams().token

      if (agent.device.type === 'mobile' || agent.device.type === 'tablet') {
        if (environment === 'devtest') {
          return this.navigateToExternalRoute(
            `reverdev://remember?token=${token}`
          )
        }

        if (environment === 'preprod') {
          return this.navigateToExternalRoute(
            `reverstage://remember?token=${token}`
          )
        }

        if (environment === 'production') {
          return this.navigateToExternalRoute(
            `reverapp://remember?token=${token}`
          )
        }
      }

      return false
    },

    async getResetPasswordToken() {
      try {
        const token = this.getRouteParams().token
        const response = await api.account.getResetPasswordToken(token)

        if (!response.data) {
          this.tokenIsValid = false
          return this.tokenIsValid
        }

        this.account = response.data.account
        return
      } catch (err) {
        this.tokenIsValid = false
        this.hasError = true
      }
    },

    async changePassword() {
      try {
        if (!this.password) return false

        this.isLoading = true

        const token = this.getRouteParams().token

        const response = await api.account.changePasswordWithToken(
          token,
          this.password
        )
        this.setLoginData(response.data)
        this.navigateTo(this.$route.query?.redirect ?? '/home')
      } catch (err) {
        this.showError(
          this.$t('auth.register.error_updating_the_account_contact_support')
        )
      } finally {
        this.isLoading = false
      }
    },

    onPasswordUpdated(password) {
      this.password = password
    },

    onClickGoTo() {
      this.$track('user.Recover', this.$store, {
        process: 'requestNewLink',
      })
      this.navigateTo({ name: 'access', params: { expiredLink: true } })
    },
  },
}
</script>
<style lang="scss" scoped>
.loginCard {
  padding: 42px 52px;
}
</style>
